import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import EmergencyRestore from "@/components/emergency/EmergencyRestore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Page de restauration d'urgence - accessible sans connexion */}
        <Route path="/emergency-restore" element={<EmergencyRestore />} />
        {/* Application principale */}
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
